export default function PhilipsHue({ integration }) {
    return null;
}